export const TOAST_DISMISSED = "TOAST_DISMISSED";
export const USER_ACTIVATION_SUCCESS = "USER_ACTIVATION_SUCCESS";
export const USER_ACTIVATION_FAILURE = "USER_ACTIVATION_FAILURE";
export const COOKIE_NOTIFICATION_PROMPTED = "COOKIE_NOTIFICATION_PROMPTED";
